import { render, staticRenderFns } from "./noticeRelease.vue?vue&type=template&id=aea87a38&scoped=true"
import script from "./noticeRelease.vue?vue&type=script&lang=js"
export * from "./noticeRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea87a38",
  null
  
)

export default component.exports